import React, { Component } from 'react';
import { Modal, Form, FormGroup, ControlLabel, FormControl, HelpBlock, ButtonToolbar, Button } from 'react-bootstrap';

export class CurrenciesForm extends Component {
    constructor(props) {
        super(props);

        this.state = {
            model: this.props.model,
            nameInputError: null,
            symbolInputError: null,
        }
    }

    // -----------------

    onChangeValue(e, property) {
        const { model } = this.state;

        model[property] = e.target.value;

        this.setState({
            model: model
        });
    }

    onSelectValue(e, property) {
        const { model } = this.state;

        model[property] = e;

        this.setState({
            model: model
        });
    }

    onSave() {
        if (this.validInput()) {
            const { model } = this.state;
            this.props.onSave(model);
        }
    }

    validInput() {
        let errors = 0;
        let nameInputError = null;
        let symbolInputError = null;

        const { model } = this.state;

        if ("" === model.name || null === model.name || undefined === model.name) {
            nameInputError = 'error';
            errors++;
        }

        if ("" === model.symbol || null === model.symbol || undefined === model.symbol) {
            symbolInputError = 'error';
            errors++;
        }

        this.setState({
            nameInputError: nameInputError,
            symbolInputError: symbolInputError,
        });

        return 0 === errors;
    }

    // -------------------

    render() {
        const { model } = this.state;
        
        if (undefined === model || null === model) {
            return null;
        }
        
        const { title } = this.props;
        const { nameInputError, symbolInputError } = this.state;

        return (
            <Modal show={true}>
                <Modal.Header>
                    <Modal.Title>{title}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <FormGroup controlId="formName" validationState={nameInputError}>
                            <ControlLabel>Nome</ControlLabel>
                            <FormControl
                                type="text"
                                value={model.name}
                                placeholder="Nome"
                                onChange={(e) => this.onChangeValue(e, "name")} />

                            {nameInputError !== null ?
                                <HelpBlock> Este campo não pode estar vazio. </HelpBlock> :
                                null
                            }
                        </FormGroup>

                        <FormGroup controlId="formSymbol" validationState={symbolInputError}>
                            <ControlLabel>Símbolo</ControlLabel>
                            <FormControl
                                type="text"
                                value={model.symbol}
                                placeholder="Símbolo"
                                onChange={(e) => this.onChangeValue(e, "symbol")} />

                            {symbolInputError !== null ?
                                <HelpBlock> Este campo não pode estar vazio. </HelpBlock> :
                                null
                            }
                        </FormGroup>
                    </Form>
                    <ButtonToolbar>
                        <Button onClick={() => this.onSave()}> GUARDAR ALTERAÇÕES </Button>
                        <Button onClick={() => this.props.onHide()}> CANCELAR </Button>
                    </ButtonToolbar>
                </Modal.Body>
            </Modal>
        );
    }
}
